import { normalizeText } from '@/helpers/Utils'

export const addToParent = (layers, newLayer, parentId) => {
    for (let layer of layers) {
        if (layer.id === parentId) {
            if (!layer.children) layer.children = [];
            layer.children.push(newLayer);
            return true;
        }
        if (layer.children && layer.children.length > 0) {
            const found = addToParent(layer.children, newLayer, parentId);
            if (found) return true;
        }
    }
    return false;
};

export const removeFromTree = (layers, idToDelete) => {
    for (let i = 0; i < layers.length; i++) {
        if (layers[i].id === idToDelete) {
            layers.splice(i, 1);
            return true;
        }
        if (layers[i].children && layers[i].children.length > 0) {
            const found = removeFromTree(layers[i].children, idToDelete);
            if (found) return true;
        }
    }
    return false;
};

export const updateInTree = (layers, updatedLayer) => {
    for (let layer of layers) {
        if (layer.id === updatedLayer.id) {
            layer.title = updatedLayer.title;
            return true;
        }
        if (layer.children && layer.children.length > 0) {
            const found = updateInTree(layer.children, updatedLayer);
            if (found) return true;
        }
    }
    return false;
};

export const updateVisibilityInTree = (layers, { id, visible }) => {
    for (let layer of layers) {
        if (layer.layer?.id === id) {
            layer.layer.visible = visible;
            return true;
        }

        if (layer.children && layer.children.length > 0) {
            const found = updateVisibilityInTree(layer.children, { id, visible });
            if (found) return true;
        }
    }
    return false;
};

export const findLayerById = (layers, id) => {
    for (let layer of layers) {
        if (layer.layer?.id === id) {
            return layer
        }
        if (layer.children && layer.children.length) {
            const found = findLayerById(layer.children, id)
            if (found) return found
        }
    }
    return null
}

export const hideAllLayersInTree = (layers, dispatch) => {
    layers.forEach(item => {

        if (item.type === 'layer' && item.layer) {
            dispatch('setVisibilityLayer', {
                id: item.layer.id,
                visible: false,
                item
            })
        }

        if (item.children && item.children.length) {
            hideAllLayersInTree(item.children, dispatch)
        }

    })
}

export const filterLayersBySearch = (layers, search) => {
  if (!search) return layers;

  const searchNormalized = normalizeText(search);

  const filterNodes = (nodes) => {
    return nodes
      .map(node => {
        const filteredChildren = node.children ? filterNodes(node.children) : [];
        const matches = normalizeText(node.title).includes(searchNormalized);

        if (matches || filteredChildren.length > 0) {
          return {
              ...node,
              children: filteredChildren
          };
        }

        return null;
      })
      .filter(node => node !== null);
  };

  return filterNodes(layers);
};

